import { QueryClientProvider } from '@tanstack/react-query';

import { Toaster } from '~/components/ui/sonner';
import { TooltipProvider } from '~/components/ui/tooltip';
import { queryClient } from '~/lib/query-client';
import { ThemeProvider } from './theme-provider';

/**
 * Everything the whole app needs, in one place. Mounted once, from root.tsx.
 *
 * Session side effects deliberately live in `~/features/auth/session-watcher`
 * instead of here: they need the router, which is not available this far up.
 */
export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <TooltipProvider delayDuration={200}>
          {children}
          <Toaster position="top-right" richColors closeButton />
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
